"use client";

import Image from "next/image";
import { RenderMarkdown } from "../render-markdown";

interface IconBoxProps {
  feature: {
    heading: string;
    description: string;
    image: any;
  };
  index: number;
}

export const IconBox = ({ feature }: IconBoxProps) => {
  return (
    <div className="bg-white border border-gray-100 flex flex-col gap-4 rounded-2xl p-6 h-full group cursor-pointer overflow-hidden transition-all duration-300">
      {feature.image && (
        <Image
          src={feature.image.url}
          alt={feature.image.alternativeText || "Image"}
          width={44}
          height={44}
          className="object-contain opacity-80"
        />
      )}
      <div className="h-full">
        <h3 className="text-lg font-semibold mb-1.5 text-gray-800">
          {feature.heading}
        </h3>
        <div className="text-gray-500 text-sm leading-relaxed">
          <RenderMarkdown isIconBox={true}>
            {feature.description}
          </RenderMarkdown>
        </div>
      </div>
    </div>
  );
};
